// import '@babel/polyfill';

import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import VueTagManager from 'vue-tag-manager';
import UIKit from '@uikit/ui-kit';
import UIKitEndUser from '@uikit/ui-kit/lib/ui-kit-web-end-user.min';

import '@uikit/ui-kit/colors/js/default';
// import '@uikit/ui-kit/lib/ui-kit.min.css';
import svgSpritePath from '@uikit/ui-syntax/dist/icons/svg-sprite/symbol/svg/sprite.symbol.svg';

import router from '@/app/router';
import store from '@/app/store';

import { setupI18n } from '@/app/i18n';
import { UPDATE_THEME, AUTH_CHECK } from '@/app/store/action-types';
import { setupAjax } from '@/app/utils/AjaxUtil';
import { getUrlParameter } from '@/app/utils/platformUtils';

import LanguageToggle from '@/app/components/LanguageToggle';

import DateFilter from '@/app/filters/DateFilter';
import SizeFilter from '@/app/filters/SizeFilter';
import UpperCaseFilter from '@/app/filters/UpperCaseFilter';
import FileIconFilter from '@/app/filters/FileIconFilter';
import ArchiveIconFilter from '@/app/filters/ArchiveIconFilter';

import App from '@/app/App';

Vue.config.productionTip = false;

Vue.use(VueTagManager, {
  gtmId: process.env.VUE_APP_GTM_ID.length > 1 ? process.env.VUE_APP_GTM_ID : null,
  dataLayer: {
    touchpoint: 'Web_Restore'
  }
});

Vue.use(UIKit, { svgSpritePath });
Vue.use(UIKitEndUser, { svgSpritePath });

setupAjax(store, router);
const i18n = setupI18n(store);

let theme = getUrlParameter('theme');
if (!theme) {
  theme = 'default';
}
store.dispatch(UPDATE_THEME, theme);
store.dispatch(AUTH_CHECK);

Vue.component('a-language-toggle', LanguageToggle);

Vue.filter('date', DateFilter);
Vue.filter('size', SizeFilter);
Vue.filter('uppercase', UpperCaseFilter);
Vue.filter('fileIcon', FileIconFilter);
Vue.filter('archiveIcon', ArchiveIconFilter);

sync(store, router);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
